import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="px-5 pt-16 text-center animate-fade-up">
      <div className="font-editorial italic text-6xl text-ink-900">404</div>
      <p className="text-sm text-ink-500 mt-2">{t("common.not_found_title")}</p>
      <Link to="/" className="mt-6 inline-flex items-center gap-2 rounded-full bg-corten-400 text-white px-5 py-2 text-sm font-semibold">
        <Home className="w-4 h-4" /> {t("common.back_home")}
      </Link>
    </div>
  );
}
